import { render } from "./BzButton.vue?vue&type=template&id=1548cd63&scoped=true"
import script from "./BzButton.vue?vue&type=script&lang=js"
export * from "./BzButton.vue?vue&type=script&lang=js"

import "./BzButton.vue?vue&type=style&index=0&id=1548cd63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1548cd63"]])

export default __exports__